
@if(!reverse()) {
    <img src="{{getImageUrl(team())}}" class="center-block" />
    <span class="align-bottom ms-1" ngClass="{'underline': underline()}">{{getName(team())}}</span>
} @else {
    <span class="align-bottom me-1" ngClass="{'underline': underline()}">{{getName(team())}}</span>
    <img src="{{getImageUrl(team())}}" class="img-fluid" />
}
